import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Mounted once near the app root. React Router's client-side navigation doesn't reset
// scroll position on its own, so without this, following a link (e.g. "Back to Cross-
// Domain Vehicle Functions") from deep in a long page leaves the viewport wherever it
// was on the previous page instead of at the top of the new one.
const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
};

export default ScrollToTop;
